import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";

//helpers:
import {getImageFromFilesbyKey, useWindowSize} from "../../../_metronic/_helpers";

//components:
import {Timeline} from "../../widgets";
import {CircularProgress} from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import NetgraphContainer from "./MediaPageNetgraph/NetgraphContainer";
import PDFViewer from "./PDFViewer";
import {loadParameter, loadUserParameter} from "../../redux_slices/contextSlice";

const iframeId = "videoindexerIframe";

const MediaViewer = ({
    page,
    playerId,
    videoIndexerId,
    companyId,
    videoStarted,
    insightsOptions,
    selectedInsights,
    setSelectedInsights,
    prepareGetAppearancesData,
    timelineHighlight,
    showSuggestion,
    timelineMatches,
    timeLineFeature,
    handleMatchClick,
    setShowSuggestion,
    setNodeAppearances,
    resetTimeline,
    currentRefinement,
    refine,
    hits,
    searching,
    clickedText,
}) => {
    const windowSize = useWindowSize();

    const language = useSelector(state => loadUserParameter(state, "language"));
    const useViIframe = useSelector(state => loadParameter(state, "useViIframe"));
    const videoContainer = useRef(null);
    const netgraphContainer = useRef(null);
    const [netgraphContainerHeight, setNetgraphContainerHeight] = useState(0);
    const [videoPlayerHeight, setVideoPlayerHeight] = useState(0);
    const [netgraphRatio, setNetgraphRatio] = useState(0);
    const [videoPoster, setVideoPoster] = useState("");
    const [isDesktop, setIsDesktop] = useState(false);
    const [arePlayerAndIframeSync, setArePlayerAndIframeSync] = useState(false);

    //redux:
    //store:
    // const {videoReviewData = [], isLoadingReviewData = true} = useSelector(state => state.review);
    const {info = {}, videoInfoError = {}, isLoadingVideoData = false} = useSelector(state => state.mediaItemPage);

    const videoContainerWidth = videoContainer?.current?.offsetWidth;
    const navbarHeight = document.querySelector("#netgraph_navbar")?.offsetHeight; //(useRef not taking propper height)
    const showVideoPlayer = info?.streaming_url;

    useEffect(() => {
        const width = windowSize.width;
        const _isDesktop = width > 768;
        setIsDesktop(_isDesktop);
    }, [windowSize]);

    useLayoutEffect(() => {
        // if (videoContainerWidth && (videoSrcReview || info.streaming_url)) {
        if (videoContainerWidth) {
            const applyRatio = width => {
                if (isDesktop) return (width * 9) / 16;
                else return (width * 12) / 16;
            };

            const videoRatioHeight = applyRatio(videoContainerWidth);

            setVideoPlayerHeight(videoRatioHeight);

            const videoContainerHeight = videoRatioHeight + 35; /*(timeline height)*/
            const width = windowSize.width;
            const isMobile = width < 430;

            if (isMobile) {
                setNetgraphContainerHeight(videoContainerHeight * 1.6);
            } else {
                setNetgraphContainerHeight(videoContainerHeight);
            }
        }
    }, [videoContainerWidth, info?.streaming_url, isDesktop]);

    useEffect(() => {
        const img = getImageFromFilesbyKey(
            info.files,
            info.id,
            "imgLandscape",
            info.type_id,
            "/media/dummy/video_dummy_black.png"
        );
        setVideoPoster(img);
    }, [info]);

    useEffect(() => {
        const netgraphContainerCurrentWidth = netgraphContainer?.current?.offsetWidth;

        if (netgraphContainerCurrentWidth && netgraphContainerHeight && navbarHeight) {
            const svgHeight = netgraphContainerHeight - navbarHeight;
            const ratio = netgraphContainerCurrentWidth / svgHeight;

            setNetgraphRatio(ratio);
        }
    }, [netgraphContainerHeight, netgraphContainer, navbarHeight]);

    const file = info?.files?.find(file => file.type.key === "document")?.public_url;

    // !! APANYO HARDCODED CAC !!
    useEffect(() => {
        const interval = setInterval(() => {
            var playerInstance = document.getElementById(playerId);
            var viPlayerIframe = document.getElementById(iframeId);
            if (playerInstance && viPlayerIframe && !arePlayerAndIframeSync) {
                syncVideoIndexerIframeAndVideoPlayer(playerId, iframeId);
                setArePlayerAndIframeSync(true);
                clearInterval(interval);
            }
        }, 500);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="row min-w-100">
            <div className="col-12 col-md-8 gutter-b video_player">
                <div
                    className="card w-100 rounded p-0 shadow gutter-b"
                    ref={videoContainer}
                    style={{
                        height: info.type_id === 1 ? videoPlayerHeight : netgraphContainerHeight,
                    }}
                >
                    {info.type_id === 1 ? (
                        showVideoPlayer ? (
                            <video
                                id={playerId}
                                className="card w-100 h-100 p-0"
                                src={info?.streaming_url}
                                style={{
                                    objectFit: "contain",
                                    background: "black",
                                }}
                                poster={videoPoster || ""}
                                controls
                                controlsList="nodownload"
                                type="video/mp4"
                                autoPlay
                                //muted
                            />
                        ) : (
                            <div className="w-100 rounded h-100 d-flex justify-content-center align-items-center bg-dark">
                                {isLoadingVideoData ? (
                                    <div className="w-100 h-100 rounded position-absolute d-flex justify-content-center align-items-center px-6 z-index-3">
                                        <CircularProgress />
                                    </div>
                                ) : null}
                                {videoInfoError && videoInfoError.text ? (
                                    <div className="w-100 h-100 rounded position-absolute d-flex justify-content-center align-items-center px-6 z-index-2">
                                        <div
                                            className={`alert alert-${videoInfoError.type ||
                                                "info"} font-size-h5 font-weight-bold z-index-3`}
                                        >
                                            <WarningRoundedIcon color="inherit" className="mr-5" />
                                            {videoInfoError.text}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        )
                    ) : null}
                    {file && info.type_id === 2 ? (
                        <PDFViewer currentRefinement={currentRefinement} clickedText={clickedText} file={file} />
                    ) : null}
                </div>
                {info?.type_id === 1 ? (
                    <Timeline
                        timelineHighlight={timelineHighlight}
                        totalTime={info.duration}
                        showSuggestion={showSuggestion}
                        matches={timelineMatches}
                        featuresMatches={timeLineFeature}
                        handleMatchClick={handleMatchClick}
                        tooltip={currentRefinement}
                    />
                ) : null}
            </div>

            {/* HARDCODED FOR CAC */}
            {/* {true && videoIndexerId ? ( */}
            {useViIframe && useViIframe !== 0 && useViIframe.toLowerCase() !== "false" && videoIndexerId ? (
                <div className="col-12 col-md-4">
                    <div
                        className="card card-custom card-stretch category-network-chart-container gutter-b"
                        ref={netgraphContainer}
                        style={{height: netgraphContainerHeight || 500}}
                    >
                        <iframe
                            id={iframeId}
                            src={`https://www.videoindexer.ai/embed/insights/cf5e7896-b4c1-4370-90a5-de99c09843f3/${videoIndexerId}/?&locale=${language}&location=westus2`}
                            frameborder="0"
                            width="100%"
                            height="780px"
                            allowfullscreen
                        ></iframe>
                        <div
                            style={{height: "40px", "background-color": "white", position: "relative", top: "-20px"}}
                        ></div>
                    </div>{" "}
                </div>
            ) : (
                <NetgraphContainer
                    page={page}
                    videoSrcReview={info?.streaming_url}
                    netgraphContainer={netgraphContainer}
                    netgraphContainerHeight={netgraphContainerHeight}
                    netgraphRatio={netgraphRatio}
                    showMasterNodesLabels={info?.type_id === 1}
                    videoStarted={videoStarted}
                    insightsOptions={insightsOptions}
                    selectedInsights={selectedInsights}
                    setSelectedInsights={setSelectedInsights}
                    prepareGetAppearancesData={prepareGetAppearancesData}
                    timelineHighlight={timelineHighlight}
                    handleMatchClick={handleMatchClick}
                    showSuggestion={showSuggestion}
                    setShowSuggestion={setShowSuggestion}
                    setNodeAppearances={setNodeAppearances}
                    resetTimeline={resetTimeline}
                    currentRefinement={currentRefinement}
                    refine={refine}
                    hits={hits}
                    searching={searching}
                    // clickedText={clickedText}
                    // setClickedText={setClickedText}
                />
            )}
        </div>
    );
};

function syncVideoIndexerIframeAndVideoPlayer(playerId, iframeId) {
    // Reference your player instance
    var playerInstance = document.getElementById(playerId);
    var viPlayerIframe = document.getElementById(iframeId);

    if (playerInstance && viPlayerIframe) {
        function jumpTo(evt) {
            console.log(evt);
            var origin = evt.origin || evt.originalEvent.origin;

            // Validate that event comes from video indexer domain.
            console.log(origin);
            if (origin === "https://www.videoindexer.ai" && evt.data) {
                if (evt.data.time !== undefined) {
                    // Here you need to call your player "jumpTo" implementation

                    playerInstance.currentTime = evt.data.time;
                }

                if (evt.data.language !== undefined) {
                    // Here you will need to call your "change language" implementation
                    playerInstance.language = evt.data.language;
                }

                // Confirm arrival to us
                if ("postMessage" in window) {
                    evt.source.postMessage({confirm: true, time: evt.data.time}, origin);
                }
            }
        }

        // Listen to message event
        window.addEventListener("message", jumpTo, false);

        // Notify VI
        playerInstance.addEventListener("timeupdate", function() {
            let payload = {
                currentTime: this.currentTime,
                origin: "https://wus2.videoindexer.ai",
            };
            if ("postMessage" in window) {
                try {
                    viPlayerIframe.contentWindow.postMessage(payload, payload.origin);
                } catch (error) {
                    throw error;
                }
            }
        });
    }
}

export default MediaViewer;
